<template>
  <div class="file-library-wrapper">
    <gd-modal ref="filePicker" name="file-picker" width="100%" height="100%">
      <div class="relative w-full flex flex-col justify-start">
        <div class="w-full bg-white">
          <div class="flex justify-between pt-3">
            <gd-tabs
              ref="tabs"
              dark
              :tabs="tabs"
              :activeByDefault="tabs[0]"
              :tabsWithErrors="tabsWithErrors"
              @tab-change="handleTabChange"
              @onClick="onTabClick"
            >
            </gd-tabs>
            <div class="flex">
              <gd-button
                :key="selectedFile.id"
                v-if="currentTab === 'File Library'"
                :disabled="selectedFile.id < 1"
                primary
                size="auto"
                class="mr-4 p-4 mt-2"
                @click="emitSelection()"
              >
                Select
              </gd-button>

              <gd-button
                size="auto"
                class="mr-4 p-4 mt-2"
                @click="closeFilePickerModal()"
              >
                Exit
              </gd-button>
            </div>
          </div>
          <div class="steps-wrapper">
            <div>
              <div class="steps-inner p-5">
                <div v-if="currentTab === 'File Library'">
                  <my-files
                    :allowedFiles="searchable"
                    :value="selectedFile"
                    @selected="selectFile"
                  ></my-files>
                </div>
                <div v-if="currentTab === 'Upload File'">
                  <file-upload
                    :allowedFiles="selectable"
                    @selected="selectFile($event, sendBackToLibrary)"
                  />
                </div>
                <div v-if="currentTab === 'External URL' && searchable === '*'">
                  <external-url @selected="selectFile($event, emitSelection)" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </gd-modal>
  </div>
</template>
<script>
import GdTabs from '@groovepages/gd-ui-kit/components/Tabs';
import GdModal from '@groovepages/gd-ui-kit/components/Modal';
import MyFiles from './MyFiles';
import FileUpload from './FileUpload';
import ExternalUrl from './ExternalUrl';

export default {
  name: 'FileLibrary',
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          id: 0,
        };
      },
    },
    allowedFiles: {},
  },
  data() {
    return {
      selectedFile: {},
      currentTab: 'File Library',
      tabsWithErrors: [],
      inactiveTabs: [],
    };
  },
  computed: {
    tabs() {
      if (this.searchable === '*') {
        return ['File Library', 'Upload File', 'External URL'];
      }

      return ['File Library', 'Upload File'];
    },
    searchable() {
      if (this.allowedFiles === '*') {
        return '*';
      } else if (this.allowedFiles === 'pdf') {
        return 'pdf';
      } else if (this.allowedFiles === 'audio') {
        return 'audio';
      }
    },
    selectable() {
      if (this.allowedFiles === '*') {
        return null;
      } else if (this.allowedFiles === 'pdf') {
        return 'application/pdf';
      } else if (this.allowedFiles === 'audio') {
        return 'audio/*';
      }
    },
  },
  components: {
    GdTabs,
    GdModal,
    MyFiles,
    FileUpload,
    ExternalUrl,
  },
  mounted() {
    this.selectFile(this.value);
  },
  methods: {
    selectFile(file, next = null) {
      this.selectedFile = { ...file };

      if (next) {
        next();
      }
    },
    sendBackToLibrary() {
      this.$refs.tabs.openTab('File Library');
    },
    emitSelection() {
      this.$emit('selected', this.selectedFile);
      this.closeFilePickerModal();
    },
    openFilePickerModal() {
      this.$refs.filePicker.open();
      this.$emit('opened');
    },
    closeFilePickerModal() {
      this.$refs.filePicker.close();
      this.$emit('closed');
    },
    handleTabChange(param) {
      this.currentTab = param;
    },
    onTabClick(param) {
      console.log('onTabClick', param);
    },
  },
};
</script>
<style scoped>
.steps-inner {
  height: calc(100vh - 145px);
}
</style>